import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation, { getContainerClass } from '../navigation/navigation';
import Header from '../header/header';

const SIDEBAR_BREAKPOINT = 992; // tablet and phone: sidebar closed by default

// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

const getInitialSidebarOpen = () => {
  if (typeof window === 'undefined') return true;
  const isTabletOrPhone = window.innerWidth <= SIDEBAR_BREAKPOINT;
  if (isTabletOrPhone) return false;
  try {
    const saved = localStorage.getItem('sidebarState');
    return saved !== null ? JSON.parse(saved) : true;
  } catch {
    return true;
  }
};

const MainLayout = () => {
  const location = useLocation();
  const [isSidebarOpen, setLayoutSidebarOpen] = useState(getInitialSidebarOpen);

  // On tablet/phone keep sidebar closed; on desktop restore from localStorage on resize
  useEffect(() => {
    const handleResize = () => {
      const isTabletOrPhone = window.innerWidth <= SIDEBAR_BREAKPOINT;
      if (isTabletOrPhone) {
        setLayoutSidebarOpen(false);
      } else {
        try {
          const saved = localStorage.getItem('sidebarState');
          setLayoutSidebarOpen(saved !== null ? JSON.parse(saved) : true);
        } catch {
          setLayoutSidebarOpen(true);
        }
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSidebarToggle = () => {
    setLayoutSidebarOpen((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('sidebarState', JSON.stringify(next));
      } catch (_) {}
      return next;
    });
  };

  const containerClass = `${getContainerClass(location.pathname)} ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`;

  return (
    <>
      <ScrollToTop />
      <Header />
      <Navigation isSidebarOpen={isSidebarOpen} onSidebarToggle={handleSidebarToggle} />
      <div className={containerClass}>
        <Outlet />
      </div>
    </>
  );
};

export default MainLayout; 